import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { AccordionModule } from 'primeng/accordion';
import { AvatarModule } from 'primeng/avatar';
import { TagModule } from 'primeng/tag';

import { FreyaCommonModule } from '../../../../freya-common/freya-common.module';

@Component({
    selector: 'app-dispatch-route-threads',
    standalone: true,
    imports: [
        CommonModule,
        FreyaCommonModule,
        AccordionModule,
        AvatarModule,
        TagModule,
    ],
    templateUrl: './dispatch-route-threads.component.html',
    styleUrl: './dispatch-route-threads.component.scss',
})
export class DispatchRouteThreadsComponent implements OnChanges {

    /** The asset ID for this route */
    @Input() assetId: string;

    /** Threads loaded from the store */
    @Input() threads: any[] = [];

    constructor(private store: Store) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['assetId']?.currentValue) {
            this.loadThreads();
        }
    }

    private loadThreads(): void {
        if (!this.assetId) { return; }
        // Trigger loading threads for this asset
        // (Effect will dispatch listAssetScheduleThreads query)
    }

    getRecipientsLabel(thread: any): string {
        if (!thread.metadata) { return ''; }
        try {
            const meta = typeof thread.metadata === 'string'
                ? JSON.parse(thread.metadata)
                : thread.metadata;
            const recipients = meta?.crewRecipients;
            if (!recipients?.length) { return ''; }
            return `Sent to ${recipients.length} crew`;
        } catch {
            return '';
        }
    }

    trackByThreadId(_: number, thread: any): string {
        return thread.id;
    }
}
